export default "__VITE_ASSET__0XFvIO0s__"